export const FilterHeader = ({title, className}) => {
    return (
        <div className={`font-bold mt-5 text-sm ${className}`}>{title}</div>
    )
}